import { useEffect } from 'react';
import initializePerformanceMonitoring from 'lib/firebase/firebase_performance';

const InitFirebasePerformance = () => {
  useEffect(() => {
    initializePerformanceMonitoring();
  }, []);
  return null;
};

export default InitFirebasePerformance;
